'use strict';

module.exports = returner;

function returner(value) {
  return value;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/util/returner.js
// module id = 112
// module chunks = 96961042003272 139266963665775